import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Logo from './logo/';
import UserInfo from '@ifeng/ui_pc_userInfo';
import Search from '@ifeng/ui_pc_search';

/**
 * 定义 LogoLine 组件
 */
class LogoLine extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { logo, search },
        } = this.props;

        return (
            <div className={styles.logoLine_border_banner}>
                <div className={styles.logoLine}>
                    <Chip id="50002" type="struct" title="大风号logo" groupName="头部" content={logo}>
                        <Logo />
                    </Chip>
                    <div className={styles.rightPart}>
                        <div className={styles.loginBox}>
                            <UserInfo />
                        </div>
                        <div className={styles.searchBox}>
                            <Search content={search} expand />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LogoLine);
